// Global components registration

import MainLayout from '@layouts/MainLayout.vue';

import Container from '@components/BaseComponents/Container.vue';
import Icon from '@components/BaseComponents/Icon.vue';
import Button from '@components/BaseComponents/Button.vue';
import Checkbox from '@components/BaseComponents/Checkbox.vue';

import 'hooper/dist/hooper.css';

Vue.component('main-layout', MainLayout);

Vue.component('container', Container);
Vue.component('icon', Icon);
Vue.component('btn', Button);
Vue.component('checkbox', Checkbox);
